'use client';

import type { IEnglishIqItem } from '@repo/sdk';

interface IEnglishIqChoiceAnswerProps {
  disabled: boolean;
  item: IEnglishIqItem;
  onAnswer: (answer: string) => void;
}

export function EnglishIqChoiceAnswer({
  disabled,
  item,
  onAnswer,
}: IEnglishIqChoiceAnswerProps): React.JSX.Element {
  return (
    <fieldset className="grid content-start gap-3">
      <legend className="sr-only">{item.prompt}</legend>
      {item.choices.map((choice) => (
        <button
          key={choice.id}
          type="button"
          disabled={disabled}
          onClick={() => onAnswer(choice.id)}
          className="min-h-14 rounded-2xl border border-foreground/10 bg-card px-5 py-4 text-start font-medium text-foreground shadow-sm transition hover:-translate-y-0.5 hover:border-violet-500/50 hover:shadow-md motion-reduce:transform-none motion-reduce:transition-none disabled:cursor-wait disabled:opacity-60"
          dir="auto"
        >
          {choice.text}
        </button>
      ))}
    </fieldset>
  );
}
